// extracted by mini-css-extract-plugin
export var button = "footer-module--button--xHu6V";
export var container = "footer-module--container--ddK-w";
export var icon = "footer-module--icon--TUN-W";
export var name = "footer-module--name--hTeSZ";
export var quote = "footer-module--quote--IUjGN";
export var section = "footer-module--section--Z0tbD";
export var show = "footer-module--show--ivRlQ";